/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon24Solid = forwardRef('WeatherUmbrellaIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.25 1.75a1.25 1.25 0 0 0-2.5 0v1.324c-4.988.591-8.903 4.678-9.228 9.743-.043.661.49 1.183 1.116 1.183h8.112v5.5a1 1 0 0 1-2 0 1.25 1.25 0 1 0-2.5 0 3.5 3.5 0 1 0 7 0V14h8.112c.626 0 1.159-.522 1.116-1.183-.325-5.065-4.24-9.152-9.228-9.743V1.75Z" })));
});
